<template>
    <v-container>
        <v-row v-if="ListBag.length < 1">
            <v-col offset="1" :cols="10">
                <p class="display-1">Nothing In Your Bag</p>
            </v-col>
        </v-row>
        <v-row v-if="ListBag.length > 0 && CardsToShow">
            <v-col :cols="12" :sm="12" :md="12" :lg="3" v-for="distance in ListBag" :key="distance.id">
                <DiscCardViewSmall
                    :id="distance.id"
                    :model="distance.model"
                    :brand="distance.brand"
                    :subtitle="distance.stability + ' ' + distance.type"
                    :speed="distance.speed"
                    :glide="distance.glide"
                    :turn="distance.turn"
                    :fade="distance.fade"
                    :skill="distance.skill"
                    :isBag="true"
                    :image="distance.image"
                    :shop="distance.shop"
                ></DiscCardViewSmall>
            </v-col>
        </v-row>
        <v-row v-if="ListBag.length > 0 && !CardsToShow">
            <v-col :cols="12" :sm="12" :md="12" :lg="6" v-for="distance in ListBag" :key="distance.id">
            <DiscCardView
                    :id="distance.id"
                    :model="distance.model"
                    :brand="distance.brand"
                    :subtitle="distance.stability + ' ' + distance.type"
                    :speed="distance.speed"
                    :glide="distance.glide"
                    :turn="distance.turn"
                    :fade="distance.fade"
                    :skill="distance.skill"
                    :isBag="true"
                    :image="distance.image"
                    :shop="distance.shop"
                ></DiscCardView>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import DiscCardViewSmall from "../components/DiscCard/DiscCardViewSmall";
import DiscCardView from "../components/DiscCard/DiscCardView";
export default {
    name: "MyBag",
    props: {},
    components: {
        DiscCardViewSmall, DiscCardView
    },
    data: () => ({

    }),
    methods: {},
    computed: {
        ...mapGetters(["GetBag"]),
        ListBag: function()
        {
            return this.GetBag;
        },
        CardsToShow()
        {
            switch(this.$vuetify.breakpoint.name)
            {
                case "xs": return true;
                case "sm": return true;
                case "md": return true;
                case "lg": return false;
                case "xl": return false;
                default: return false;
            }
        }
    },
}
</script>